import React from 'react';
import { RewardPointContainerStyled } from './styled';
import { withRouter } from 'navigations/withRouter';
import { ROUTE_PATH } from 'utils/constants/routePath';
import { scrollToTopPageFN } from 'utils/functions/scrollTopPage';
import { portalService } from 'apiServices';
import moment from 'moment';
import 'moment-timezone';
import { MdAdd, MdSort, MdCardGiftcard } from 'react-icons/md';
import * as XLSX from 'xlsx';
import { RenderCommaMoney } from 'utils/functions/FormatMoney';
import { REWARD_RENDER_TYPE } from 'utils/functions/reward';
import { RewardSort, RewardGiftContainer } from '../Modals';
import { Buttons, Inputs, Displays, Tables, Modals } from 'components';

const FILTER_FIELDS = ['type', 'is_active', 'name'];

// แปลง query string ของ url เป็น state ของ filter (ใช้ตอนเข้าหน้าครั้งแรก / กดกลับมาจากหน้า detail)
const parseUrlQuery = (search) => {
  const searchParams = new URLSearchParams(search || '');
  const currentPage = Number(searchParams.get('page')) || 1;
  searchParams.delete('page');
  let filterValues = {};
  FILTER_FIELDS.forEach((key) => {
    filterValues[key] = searchParams.get(key) || '';
    if (!filterValues[key]) {
      searchParams.delete(key);
    }
  });
  const filterString = searchParams.toString();
  return {
    filterQuery: filterString ? `?${filterString}` : '',
    filterValues,
    currentPage,
  };
};

class RewardPointContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
    // เปลี่ยน key เพื่อบังคับสร้าง InputFilter ใหม่ตอนกดล้างค่า
    filterKey: 0,
    // เก็บ filter เดิมไว้ที่ url เพื่อให้กดกลับมาจากหน้า detail แล้ว filter ยังอยู่
    ...parseUrlQuery(this.props.router.location.search),
  };

  componentDidMount() {
    const { perPage, filterQuery, currentPage } = this.state;
    scrollToTopPageFN();
    if (!filterQuery && currentPage === 1) {
      this.fetchData(`?limit=${perPage}&sort=sequence&is_delete=true`);
    } else {
      this.handleJoinQuery(filterQuery, perPage, currentPage);
    }
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_REWARD_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
        },
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    const parsedQuery = parseUrlQuery(e);
    this.setState({
      ...parsedQuery,
    });
    this.handleJoinQuery(parsedQuery.filterQuery, perPage, 1);
  };

  handleClearFilter = () => {
    const { perPage } = this.state;
    this.setState((prevState) => ({
      ...parseUrlQuery(''),
      filterKey: prevState.filterKey + 1,
    }));
    this.handleJoinQuery('', perPage, 1);
  };

  handleClickCreate = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.REWARD_POINT_DETAIL}/${e}`, {
      state: { search: this.props.router.location.search },
    });
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}&sort=sequence&is_delete=true`
      : `?limit=${per_page}&page=${page}&sort=sequence&is_delete=true`;
    this.setState({
      isLoading: true,
      currentPage: page,
    });
    this.handleSyncUrlQuery(query, page);
    this.fetchData(joinQuery);
  };

  handleSyncUrlQuery = (query, page) => {
    const searchParams = new URLSearchParams(query || '');
    Array.from(searchParams.keys()).forEach((key) => {
      if (!searchParams.get(key)) {
        searchParams.delete(key);
      }
    });
    if (page > 1) {
      searchParams.set('page', page);
    }
    const search = searchParams.toString();
    this.props.router.navigate(
      { search: search ? `?${search}` : '' },
      { replace: true }
    );
  };

  // export ตามเงื่อนไข filter ที่ค้นหาอยู่ (ดึงทุกหน้าด้วย pagination=false)
  handleExport = async () => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false&sort=sequence&is_delete=true`
      : `?pagination=false&sort=sequence&is_delete=true`;
    let res = await portalService.GET_REWARD_LIST(joinQuery);
    if (res && res.status === 200) {
      var wb = XLSX.utils.book_new();
      var ws_name = 'SheetJS';
      var ws_data = res.data.docs.reduce((result, e, i) => {
        result.push([
          i + 1,
          moment(e.created_at).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm'),
          REWARD_RENDER_TYPE(e.type),
          e.code,
          e.name,
          e.expired_at
            ? moment(e.expired_at).tz('Asia/Bangkok').format('DD/MM/YYYY')
            : '',
          RenderCommaMoney(Number(e.redeem_point), true),
          RenderCommaMoney(Number(e.cost), true),
          RenderCommaMoney(Number(e.total_amount), true),
          RenderCommaMoney(Number(e.redeem_amount), true),
          RenderCommaMoney(Number(e.total_amount - e.redeem_amount), true),
          e.is_active === true ? 'แสดง' : 'ไม่แสดง',
        ]);
        return result;
      }, []);
      ws_data.splice(0, 0, [
        'No',
        'Crate Date',
        'Redeem type',
        'Reward code',
        'Reward Name',
        'Expired date',
        'Redeem Point',
        'Cost',
        'Total Amount',
        'Total Redeem',
        'Total Remain',
        'Display',
      ]);
      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      ws['!cols'] = [
        { wch: 5 },
        { wch: 20 },
        { wch: 15 },
        { wch: 20 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        { wch: 12 },
      ];
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `Reward report ${moment().tz('Asia/Bangkok').format('DD/MM/YYYY')}.xlsx`
      );
    }
    this.setState({
      isBgLoading: false,
    });
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: false,
    });
  };

  handleClickSort = () => {
    this.setState({
      renderModal: <RewardSort onUpdated={this.handleReloadCurrentPage} />,
    });
  };

  handleReloadCurrentPage = () => {
    const { filterQuery, perPage, currentPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, currentPage);
  };

  handleClickGift = (id) => {
    this.setState({
      renderModal: (
        <RewardGiftContainer id={id} onGiftSuccess={this.handleGiftSuccess} />
      ),
    });
  };

  handleGiftSuccess = () => {
    this.handleCloseModal();
    this.handleReloadCurrentPage();
  };

  render() {
    const {
      isLoading,
      isBgLoading,
      pagination,
      renderModal,
      data,
      filterValues,
      filterKey,
    } = this.state;
    return (
      <RewardPointContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="btn_create">
          <div className="w120">
            <Buttons.BgIconPrefix
              label="New"
              icon={<MdAdd size={18} />}
              onClick={() => this.handleClickCreate('create')}
            />
          </div>
          <div className="w120">
            <Buttons.BgIconPrefix
              label="Sort"
              icon={<MdSort size={18} />}
              onClick={() => this.handleClickSort()}
            />
          </div>
        </div>
        <Inputs.InputFilter
          key={filterKey}
          theme_standard_input_filter
          dataFilter={dataFilter(filterValues)}
          btnLabel="ค้นหา"
          clearLabel="ล้างค่า"
          onQueryFilter={this.handleFilterKeyword}
          onClear={this.handleClearFilter}
          onExport={this.handleExport}
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <>
            <div className="body_table  ">
              <Tables.Standard
                columns={columns({
                  handleClickDetail: this.handleClickCreate,
                  handleClickGift: this.handleClickGift,
                })}
                data={data}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
              />
            </div>
          </>
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </RewardPointContainerStyled>
    );
  }
}

const dataFilter = (filterValues) => [
  {
    accessor: 'type',
    length: '311px',
    filter: {
      fieldQuery: 'type',
      type: 'dropdown',
      defaultValue: filterValues.type,
      options: [
        {
          label: 'All',
          value: '0',
        },
        {
          label: 'E-coupon',
          value: '1',
        },
        {
          label: 'Coupon',
          value: '2',
        },
        {
          label: 'Other',
          value: '3',
        },
      ],
      placeholder: 'Redeem type',
      label: 'Redeem type : ',
    },
  },
  {
    accessor: 'is_active',
    length: '311px',
    filter: {
      fieldQuery: 'is_active',
      type: 'dropdown',
      defaultValue: filterValues.is_active,
      options: [
        {
          label: 'All',
          value: '',
        },
        {
          label: 'แสดง',
          value: 'true',
        },
        {
          label: 'ไม่แสดง',
          value: 'false',
        },
      ],
      placeholder: 'Display status',
      label: 'Display : ',
    },
  },
  {
    accessor: 'name',
    length: '311px',
    filter: {
      fieldQuery: 'name',
      type: 'text',
      defaultValue: filterValues.name,
      label: 'Reward search',
      placeholder: 'Reward name',
    },
  },
];

const columns = ({ handleClickDetail, handleClickGift }) => [
  {
    Header: <div style={{ textAlign: 'left' }}>Crate Date</div>,
    accessor: 'created_at',
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {moment(props.value).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm')}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Reward Name</div>,
    accessor: 'name',
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Redeem Point</div>,
    accessor: 'redeem_point',
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Cost</div>,
    accessor: 'cost',
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Total Amount</div>,
    accessor: 'total_amount',
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Total Redeem</div>,
    accessor: 'redeem_amount',
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {RenderCommaMoney(Number(props.value), true)}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Total Remain</div>,
    accessor: 'total_reamin',
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {RenderCommaMoney(
          Number(
            props.row.original.total_amount - props.row.original.redeem_amount
          ),
          true
        )}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: 'left' }}>Display</div>,
    accessor: 'is_active',
    Cell: (props) => (
      <div
        className="body_status"
        onClick={() => handleClickDetail(props.row.original._id)}
      >
        <div
          className="round"
          style={{ background: props.value === true ? 'green' : 'red' }}
        />
        <div className="label_status">
          {props.value === true ? 'แสดง' : 'ไม่แสดง'}
        </div>
      </div>
    ),
  },
  {
    Header: 'Action',
    accessor: 'action',
    Cell: (props) =>
      props.row.original.type === '1' &&
      props.row.original.redeem_amount < props.row.original.total_amount ? (
        <div
          style={{ textAlign: 'right' }}
          onClick={() => handleClickGift(props.row.original._id)}
        >
          <MdCardGiftcard size={24} />
        </div>
      ) : (
        <></>
      ),
  },
];

export default withRouter(RewardPointContainer);
